import { z } from 'zod';
import {
  AmericanFinalBracketSize,
  FixtureType,
  OverflowGroupClassification,
  TournamentFormat,
} from '@/types/tournament.model';

/**
 * Validation schema for the Padel Fixture Config step.
 * Supports all three FixtureType values (including GROUPS_ONLY for LONG).
 */
export const padelFixtureConfigStepSchema = z.object({
  fixtureType: z.nativeEnum(FixtureType, {
    errorMap: () => ({ message: 'Selecciona un formato de torneo' }),
  }),
  format: z.nativeEnum(TournamentFormat, {
    errorMap: () => ({ message: 'Selecciona el tipo de torneo (SHORT, AMERICAN o LONG)' }),
  }),
  teamsPerGroups: z
    .number()
    .min(2, 'Mínimo 2 equipos por grupo')
    .max(8, 'Máximo 8 equipos por grupo'),
  classifiedPerGroups: z
    .number()
    .min(1, 'Al menos 1 equipo debe clasificar'),
  minTeamsAllowed: z
    .number()
    .min(2, 'Debe haber al menos 2 equipos'),
  maxTeamsAllowed: z
    .number()
    .min(2, 'Debe haber al menos 2 equipos'),
  overflowGroupClassification: z
    .nativeEnum(OverflowGroupClassification)
    .optional(),
  americanFinalBracketSize: z
    .nativeEnum(AmericanFinalBracketSize)
    .optional(),
})
  .refine(
    (data) => data.minTeamsAllowed <= data.maxTeamsAllowed,
    {
      message: 'El mínimo de equipos no puede ser mayor al máximo',
      path: ['minTeamsAllowed'],
    },
  );

export type PadelFixtureConfigStepData = z.infer<typeof padelFixtureConfigStepSchema>;
